// 从 'vue' 包中导入 createApp 函数，用于创建一个 Vue 应用实例
import { createApp } from 'vue';

// 导入根组件 App.vue，后面会把它作为整个应用的最顶层组件
import App from './App.vue';

// 导入路由配置（router.js），用于管理页面间的跳转和 URL 映射
import router from './router';


const API_BASE = 'http://110.40.74.118:3345/api.php';

function fetchData(url, options) {
  const useNative =
    typeof window.nativeFetch === 'function' &&
    window.webkit?.messageHandlers?.fetchHandler;

  if (useNative) {
    // 如果是相对路径，就拼成绝对 URL
    let fullUrl = url;
    if (url.startsWith('/api/')) {
      // '/api/video/homeRecommend' -> 'http://110.40.74.118:3345/api.php/video/homeRecommend'
      fullUrl = API_BASE + url.replace(/^\/api/, '');
    }
    return window.nativeFetch(fullUrl);
  } else {
    // 浏览器环境下，继续用原来的 fetch（会走 vue-cli proxy）
    return fetch(url, options).then(res => {
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      return res.json();
    });
  }
}


// 使用 createApp 创建一个 Vue 应用实例，并把 App 组件挂载为根组件
const app = createApp(App);

// 在应用实例上注册路由插件，让整个应用都能使用路由功能
app.use(router);

app.config.globalProperties.$fetchData = fetchData;

// 把应用挂载到页面上 id 为 "app" 的 DOM 元素中，开始渲染界面
app.mount('#app');